<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-overlay :show="loading" rounded="md" variant="transparent">
            <validation-observer ref="detailDepartmentRuleValidate">
              <b-form ref="detailDepartmentFormElement">
                <b-row>
                  <b-col sm="6" lg="4">
                    <b-form-group label-for="name" :label="t('Name')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Name')"
                        rules="required|alpha_spaces"
                      >
                        <b-form-input
                          id="name"
                          v-model="values.name"
                          name="name"
                          type="text"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Name')"
                          :tabindex="1"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="type">{{ t('Type') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider #default="{ errors }" :name="t('Type')" rules="required">
                        <b-form-select
                          id="type"
                          v-model="values.type"
                          :state="errors.length > 0 ? false : null"
                          :options="[{ text: t('Make a Choice'), value: '' }].concat(typeOptions)"
                          tabindex="3"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="key">{{ t('Key') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider #default="{ errors }" :name="t('Key')" rules="required">
                        <b-form-select
                          id="key"
                          v-model="values.key"
                          :state="errors.length > 0 ? false : null"
                          :options="[{ text: t('Make a Choice'), value: '' }].concat(keyOptions)"
                          tabindex="3"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="condition">{{ t('Condition') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Condition')"
                        rules="required"
                      >
                        <b-form-select
                          id="condition"
                          v-model="values.condition"
                          :state="errors.length > 0 ? false : null"
                          :options="
                            [{ text: t('Make a Choice'), value: '' }].concat(conditionOptions)
                          "
                          tabindex="3"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="value">{{ t('Value') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Value')"
                        rules="required"
                      >
                        <b-form-input
                          id="type"
                          v-model="values.value"
                          name="type"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Value')"
                          tabindex="3"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="6" lg="4">
                    <b-form-group>
                      <div class="d-flex form-group-label">
                        <label for="name">{{ t('Status') }}</label>
                        <span class="text-danger">*</span>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Status')"
                        rules="required"
                      >
                        <b-form-select
                          id="status"
                          v-model="values.status"
                          name="status"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Status')"
                          tabindex="3"
                          :options="statusOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-button
                      variant="primary"
                      type="button"
                      block
                      class="mt-lg-2"
                      :disabled="submitting"
                      @click="submit"
                    >
                      <feather-icon icon="CheckIcon" size="15" />
                      {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-overlay>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BRow,
  BFormSelect
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BFormSelect,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,

    ValidationObserver,
    ValidationProvider
  },
  mixins: [helper],
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      states: 'app/consignorStates',
      cities: 'app/consignorCities'
    })
  },
  props: {
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          name: '',
          status: 1,
          authorized_person_name: '',
          type: '',
          key: '',
          condition: ''
        };
      }
    }
  },
  data() {
    return {
      keyOptions: [],
      typeOptions: [],
      conditionOptions: [],
      statusOptions: [],
      incomingData: {},
      loading: false,
      type: '',
      status: 1,
      key: ''
    };
  },
  mounted() {
    this.statusOptions = [
      { value: 0, text: this.$t('Passive') },
      { value: 1, text: this.$t('Active') }
    ];
  },
  async created() {
    await this.getDepartmentRuleCondition().then(response => {
      this.conditionOptions = response.map(x => ({
        text: x.info,
        value: x.value
      }));
    });
    await this.getDepartmentRuleKey().then(response => {
      this.keyOptions = response.map(x => ({
        text: x.name,
        value: x.key
      }));
    });
    await this.getDepartmentRuleType().then(response => {
      this.typeOptions = response.map(x => ({
        text: x.info,
        value: x.value
      }));
    });
  },

  methods: {
    submit() {
      this.$refs.detailDepartmentRuleValidate.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            name: this.values.name,
            status: this.values.status,
            type: this.values.type,
            key: this.values.key,
            condition: this.values.condition,
            value: this.values.value
          });
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
